import React from 'react';
import './_banner.scss';
import PropTypes from 'prop-types';

const Banner = (props) => {
  const {
    ctaMode,
    buttonMode,
    tagline,
    title,
    contactLink,
    buttonText,
    buttonLink,
  } = props;

  return (
    <div className="banner-container text-center">
      <div data-aos="fade-up" data-aos-once>
        <div className="cta-banner">
          <h1 className="title secondary">{title}</h1>
          <p className="tagline">{tagline}</p>
          {
              ctaMode
                ? <a className="contact" href={`mailto:${contactLink}`}>{contactLink}</a>
                : null
            }
          {
              buttonMode
                ? <a target="_blank" rel="noopener" href={buttonLink} className="cta btn btn-primary">{buttonText}</a>
                : null
            }
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  ctaMode: PropTypes.bool,
  buttonMode: PropTypes.bool,
  tagline: PropTypes.string,
};
export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js